import React from 'react';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import 'react-notifications/lib/notifications.css';
// import registerServiceWorker from './registerServiceWorker';
import store from './app/Store';
import Routes from './app/Routes';

import  './main.scss';

window.$ = $;
window.jQuery = $;

ReactDOM.render(
  <Provider store={store}>
    <Routes />
  </Provider>,
  document.getElementById('root'));

// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js